import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Role\GetRoleListController::__invoke
* @see app/Http/Controllers/Role/GetRoleListController.php
* @route '/api/role'
*/
const GetRoleListController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetRoleListController.url(options),
    method: 'get',
})

GetRoleListController.definition = {
    methods: ["get","head"],
    url: '/api/role',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Role\GetRoleListController::__invoke
* @see app/Http/Controllers/Role/GetRoleListController.php
* @route '/api/role'
*/
GetRoleListController.url = (options?: RouteQueryOptions) => {
    return GetRoleListController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Role\GetRoleListController::__invoke
* @see app/Http/Controllers/Role/GetRoleListController.php
* @route '/api/role'
*/
GetRoleListController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetRoleListController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Role\GetRoleListController::__invoke
* @see app/Http/Controllers/Role/GetRoleListController.php
* @route '/api/role'
*/
GetRoleListController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetRoleListController.url(options),
    method: 'head',
})

export default GetRoleListController